// Mirror of the backend shipping rate engine (productStore/shippingRates.js),
// used only to DISPLAY eligible rates at checkout. The server re-resolves +
// re-prices at checkout, so this can never be trusted for the charged amount.

// Zones store ISO codes (the salon picker writes "GB") but a country can
// arrive as a typed name — normalise the obvious aliases before matching.
const COUNTRY_ALIASES = {
  'UK': 'GB', 'UNITED KINGDOM': 'GB', 'GREAT BRITAIN': 'GB', 'ENGLAND': 'GB',
  'SCOTLAND': 'GB', 'WALES': 'GB', 'NORTHERN IRELAND': 'GB',
  'IRELAND': 'IE', 'EIRE': 'IE', 'REPUBLIC OF IRELAND': 'IE',
  'UNITED STATES': 'US', 'USA': 'US', 'UNITED STATES OF AMERICA': 'US',
};

export function normaliseCountry(country) {
  const c = (country || '').toString().trim().toUpperCase();
  return COUNTRY_ALIASES[c] || c;
}

export function resolveZone(zones, country) {
  const c = normaliseCountry(country);
  const list = Array.isArray(zones) ? zones : [];
  let star = null;
  for (const z of list) {
    const countries = (z.countries || []).map((x) => normaliseCountry(x));
    if (countries.includes(c)) return z;
    if (countries.includes('*') && !star) star = z;
  }
  return star;
}

export function eligibleRates(zone, cart) {
  if (!zone || !Array.isArray(zone.rates)) return [];
  const subtotal = Number(cart && cart.subtotal) || 0;
  const weight = Number(cart && cart.weight) || 0;
  return zone.rates
    .filter((r) => {
      if (r.minSubtotal != null && subtotal < r.minSubtotal) return false;
      if (r.maxSubtotal != null && subtotal > r.maxSubtotal) return false;
      if (r.minWeight != null && weight < r.minWeight) return false;
      if (r.maxWeight != null && weight > r.maxWeight) return false;
      return true;
    })
    .map((r) => ({ _id: r._id, name: r.name, type: r.type, price: Number(r.price) || 0 }));
}
